import apis from "../../../api";
import {
  getMyProfileAction,
  setRoleUserMenuAction,
  setTenantPermissionsInfoAction,
  setThemeStylesAction,
} from "../actionCreators/commonActionCreator";
import { setErrorHandler } from "../actionHandlers/errorActionHandler";
import { logoutActionHandler } from "../actionHandlers/loginActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
// import { resetPasswordAction } from "../actionCreators/commonActionCreator";
import { contactUsAction } from "../actionCreators/commonActionCreator";
import loaders from "../actionCreators/loadersActionCreator";
import { getHeaderUserProfileActionHandler } from "./headerActionHandler";
import {
  domains,
  isMatchingDomain,
} from "../../../utils/ltimSSOLoginCondition";
import {
  startTrackedSession,
  getTrackedSessionId,
  endTrackedSessionOnPageExit,
} from "../../../utils/sessionManager";

const { FAIL, SUCCESS } = errorTypes;
export const setThemeStylesHandler = (ThemeData) => (dispatch) => {
  const themeData = ThemeData || JSON.parse(localStorage.getItem("themeData"));

  if (themeData !== undefined && themeData?.IsCustomSetting === true) {
    dispatch(setThemeStylesAction(themeData?.CustomData?.PrimaryColor1));

    document.documentElement.style.setProperty(
      "--color-BGColor",
      themeData?.CustomData?.BGColor
    );
    // document.documentElement.style.setProperty(
    //   "--color-PaneColor",
    //   themeData?.CustomData?.PaneColor
    // );
    document.documentElement.style.setProperty(
      "--color-PaneColor",
      themeData?.CustomData?.PrimaryColor1
    );
    document.documentElement.style.setProperty(
      "--color-PrimaryColor1",
      themeData?.CustomData?.PrimaryColor1
    );
    document.documentElement.style.setProperty(
      "--color-PrimaryColor2",
      themeData?.CustomData?.PrimaryColor2
    );
    document.documentElement.style.setProperty(
      "--color-PrimaryColor3",
      themeData?.CustomData?.PrimaryColor3
    );
    document.documentElement.style.setProperty(
      "--color-PrimaryColor4",
      themeData?.CustomData?.PrimaryColor4
    );
    document.documentElement.style.setProperty(
      "--color-SecondaryColor",
      themeData?.CustomData?.SecondaryColor
    );
    document.documentElement.style.setProperty(
      "--color-TabDisable",
      themeData?.CustomData?.TabDisable
    );
    document.documentElement.style.setProperty(
      "--color-TabOnSelect",
      themeData?.CustomData?.TabOnSelect
    );
    document.documentElement.style.setProperty(
      "--color-TextColor",
      themeData?.CustomData?.TextColor
    );
  }
};

export const setPageLoaderActionHandler = (data) => async (dispatch) => {
  dispatch(loaders.common.pageLoader(data));
};
export const getTenantNameActionHandler = () => (_, getState) => {
  const tenantName = getState()?.commonReducer?.tenantName;
  return tenantName;
};

export const getMyProfileActionHandler = () => async (dispatch) => {
  return await apis.profile
    .getMyProfile()
    .then((response) => {
      if (response.status === 200 && response.data) {
        localStorage.setItem("firstName", response?.data?.FirstName);
        dispatch(getMyProfileAction(response.data));
        const token = localStorage.getItem("token");
        if (token && !getTrackedSessionId()) {
          startTrackedSession(); // fire-and-forget; idempotent — only if token exists and no active session
        }
        return response.data;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateMyProfileActionHandler =
  (userProfile, navigate) => async (dispatch) => {
    await apis.profile
      .updateMyProfile(userProfile)
      .then((response) => {
        if (response.status === 415) {
          dispatch(setErrorHandler(FAIL, "Unsupported Media Type"));
        } else if (response.status === 401) {
          dispatch(logoutActionHandler(navigate));
          console.log("getting 401");
        } else {
          dispatch(getMyProfileActionHandler());
          dispatch(setErrorHandler(SUCCESS, "Profile Picture updated"));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const resetPasswordActionHandler =
  (currentPassword, newPassword) => async (dispatch) => {
    const data = {
      OldPassword: currentPassword,
      NewPassword: newPassword,
    };
    await apis.profile
      .resetPassword(data)
      .then((response) => {
        if (response.status === 200) {
          if (response.data !== null) {
            switch (response.data.Code) {
              case 1001:
                dispatch(setErrorHandler(FAIL, response.data.Description));
                break;
              case 1002:
                dispatch(
                  setErrorHandler(
                    FAIL,
                    "Old Password and New Password should not be same"
                  )
                );
                break;
              case 1006:
                dispatch(
                  setErrorHandler(
                    SUCCESS,
                    "User Password is updated successfully"
                  )
                );
                break;
              case 1010:
                dispatch(
                  setErrorHandler(
                    FAIL,
                    "Choose a password that is different from your last 5 passwords"
                  )
                );
                break;
              default:
                break;
            }
          }
        }
      })
      .catch((error) => {
        console.log("what is errror " + error);
      });
  };

export const contactUsActionHandler =
  (data, fileBinaryData) => async (dispatch) => {
    return await apis.profile
      .contactUs(data, fileBinaryData)
      .then((response) => {
        if (response.status === 200) {
          dispatch(contactUsAction());
          dispatch(
            setErrorHandler(SUCCESS, "Your Message has been sent to Admin")
          );
        } else {
          dispatch(
            setErrorHandler(Error, "Your Message has not been sent to Admin")
          );
        }
        return response;
      })
      .catch((error) => {
        console.log("what is errror " + error);
      });
  };

export const getUserRoleMenuActionHandler = () => async (dispatch) => {
  await apis.common
    .getUserRoleMenu()
    .then((response) => {
      if (response.status === 200) {
        dispatch(setRoleUserMenuAction(response.data));
      } else {
        dispatch(setErrorHandler(Error, "Error while fetching user role menu"));
      }
    })
    .catch((error) => {
      console.log("errror" + error);
    });
};

// export const getUserRoleMenuForEventActionHandler = (setData) => async () => {
//   await apis.userRoles
//     .getUserRoleMenu()
//     .then((response) => {
//       setData(response.data);
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// };

export const getTenantPermissionInfoActionHandler =
  (navigate) => async (dispatch) => {
    await apis.common
      .getTenantPermissionInfo()
      .then((response) => {
        if (response?.status === 200)
          dispatch(setTenantPermissionsInfoAction(response?.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          if (isMatchingDomain(domains)) {
            endTrackedSessionOnPageExit();
            localStorage.clear();
            sessionStorage.clear();
            navigate("/aadlogin");
          } else navigate("login");
        } else console.log(err);
      });
  };
